class BundleOffers extends HTMLElement {
    constructor() {
        super();
        this.triggers = this.querySelectorAll('.bundle-trigger-button');
        this.addons = this.querySelectorAll('.bundle-offers__list__offer.addon_product');
        this.includes = this.querySelectorAll('.bundle-offers__list__offer.include_product');

    }

    connectedCallback() {
        this.triggers.forEach((button) => {
            button.addEventListener('click', this.openList.bind(this))
        })

        this.addons.forEach((addon) => {
            addon.addEventListener('click', this.selectAddon.bind(this))
            const selectVariant = addon.querySelector('select');
            if(selectVariant) {
              selectVariant.addEventListener('change', (event) => {
                const selectedVariant = event.currentTarget.value;
                addon.dataset.id = selectedVariant;
                this.populateAddonInput();
              });
            }
            
        })

        this.includes.forEach((addon) => {
            addon.addEventListener('click', this.selectInclude.bind(this))
        })
    }

    openList(event) {
        event.currentTarget.classList.toggle('active');
        event.currentTarget.parentElement.nextElementSibling.classList.toggle('active');
    }

    selectAddon(event) {
        
        if (event.srcElement.tagName == "SELECT") {
            return
        }
        event.currentTarget.classList.toggle('selected');
        
        this.populateAddonInput();
    }

    selectInclude(event) {
        if (event.currentTarget.dataset.type == "multi") {
            
        } else {
            if (event.currentTarget.classList.contains("selected_include")) {
                return
            }
            const existingSelected = document.querySelector('.bundle-offers__list__offer.include_product.selected_include');
    
            if (existingSelected) {
                existingSelected.classList.remove("selected_include")
            }
    
            event.currentTarget.classList.add('selected_include');
            const addonsInput = document.querySelector('input[name="included"]');
            addonsInput.value = event.currentTarget.dataset.id
        }
        
    }

    populateAddonInput() {
      const allSelected = document.querySelectorAll('.bundle-offers__list__offer.addon_product.selected');
      const allSelectedArray = []
      allSelected.forEach((selected) => {
          allSelectedArray.push(selected.dataset.id);
      })
      
      const addonsInput = document.querySelector('input[name="addons"]');
      
      addonsInput.value = allSelectedArray.join(',')
    }

}

customElements.define('bundle-offers', BundleOffers);